export default class OrderSidebar {
  constructor($scope, OrderSidebarService) {
    $scope.update_stocklist_data = function(value) {
      OrderSidebarService.set_stocklist_data(value > 0);
    };

    $scope.init = function() {
      $scope.update_stocklist_data(window.order_stock_items_count);
      $scope.stocklist_data = OrderSidebarService.get_stocklist_data();

      OrderSidebarService.set_booking_notes_data(window.order_booking_notes_count > 0);
      $scope.booking_notes_data = OrderSidebarService.get_booking_notes_data();

      OrderSidebarService.set_payment_general_data(window.payment_general_percentage);
      $scope.payment_general_data = OrderSidebarService.get_payment_general_data();

      OrderSidebarService.set_delivery_general_data(window.delivery_general_percentage);
      $scope.delivery_general_data = OrderSidebarService.get_delivery_general_data();

      OrderSidebarService.set_main_infos_data(window.main_infos_percentage);
      $scope.main_infos_data = OrderSidebarService.get_main_infos_data();
    };

    $scope.init();
  }
}

OrderSidebar.$inject = ['$scope', 'OrderSidebarService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-sidebar.ctrl.js